module.exports = __webpack_public_path__ + "img/Card.fd50df4.png";